<template>
  <b-card no-body>
    <span class="d-flex">
      <feather-icon icon="AlignJustifyIcon" size="24"/>
      <h3>ประวัติการแจ้งชำระเงิน</h3>
    </span>
    <hr/>
    <b-card-body class="d-flex">
        <div class="d-flex align-items-center mb-1">
          <span class="pr-1"> Date: </span>
          <flat-pickr v-model="date" class="form-control" :config="datePickerConfig"/>
          <span class="px-1"> - </span>
          <span class="pr-1"> Due Date: </span>
          <flat-pickr v-model="dueDate" class="form-control mr-1" :config="datePickerConfig"/>
          <b-button variant="primary" @click="getHistory()">ค้นหา</b-button>
        </div>
      </b-card-body>

    <b-table
      responsive
      class="position-relative"
      :items="history"
      :fields="fields"
    >
      <template #cell(paymentID)="data">
        <b-button	 @click="deletePayment(data.value)" class="btn-icon rounded-circle" variant="primary">
          <feather-icon class="icon" icon="Trash2Icon" size="15"/>
        </b-button>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup,
  BFormInput, BInputGroupAppend, BButton, BCardBody, BCard, BButtonClose
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { formatDate_dmy } from '@/views/global_function.js'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    flatPickr,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BCard,
    BButtonClose,
  },
  data() {
    return {
      date: null,
      dueDate: null,
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },
      history: [],
      fields: [
        { key: 'paymentDate', label: 'ชำระเวลา', sortable: true },
        { key: 'bank', label: 'ช่องทาง' },
        { key: 'description', label:'เพื่อชำระ' },
        { key: 'amountPaid', label:'ยอด(บาท)' },
        { key: 'remark', label:'หมายเหตุ' },
        { key: 'statusText', label:'สถานะ' },
        { key: 'paymentID', label:'ลบ' },
      ],
    }
  },

  created() {
    this.getHistory()
  },
  methods: {
    formatDate_dmy,
    async getHistory(){
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        "customerID": JSON.parse(localStorage.getItem('cusId')),
        "startDate": this.date,
        "endDate": this.dueDate,
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/Payment/load-payment-history-page',
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.history = keepdata.dataList
      this.date = keepdata.startDate
      this.dueDate = keepdata.endDate
    },
    async deletePayment(paymentId){
      this.$swal({
        title: 'ลบการแจ้งชำระเงิน ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการลบรายการนี้ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          var axios = require('axios');
          var data = JSON.stringify({
            // "customerID": 1,
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "paymentID": paymentId,
          });

          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/Payment/delete-payment',
            headers: {
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
            'Content-Type': 'application/json'
            },
            data : data
          };

          await axios(config)
          .then(function (response) {
          })
          .catch(function (error) {
            console.log(error);
          });
          this.getHistory()
        }
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

